import { Process } from 'types/otp';
import api from './api';

export const activateOtp = async (value: number | string, process: Process) => {
  try {
    const result = await api.post('/profile/activateSmsOtp', {
      otp: value,
      otpFlowTypeCode: process,
    });
    return result;
  } catch (error) {
    return error;
  }
};

export const activateOtpEmail = async (
  value: number | string,
  process: Process,
) => {
  try {
    const result = await api.post('/profile/activateEmailOtp', {
      otp: value,
      otpFlowTypeCode: process,
    });
    return result;
  } catch (error) {
    return error;
  }
};

export const initiateOtpRequest = async (
  countryCode: string,
  number: string,
  process: Process,
) => {
  try {
    const resp = await api.post('/profile/initiateSmsOtp', {
      countryCode,
      number,
      otpFlowTypeCode: process,
    });
    return resp;
  } catch (error) {
    return error;
  }
};

export const sendSmsOtp = async (process: Process) => {
  const result = await api.post('/profile/sendSmsOtp', {
    otpFlowTypeCode: process,
  });
  return result;
};

export const sendEmailOtp = async (process: Process) => {
  console.log;
  const result = await api.post('/profile/sendEmailOtp', {
    otpFlowTypeCode: process,
  });
  return result;
};

export const otpStatus = async () => {
  try {
    const response = await api.get('/twoFactor/elevated');
    if (response?.status === 200) return response.data;
    return [''];
  } catch (error) {
    return [''];
  }
};
